import MaterialIconsWoff from '../assets/fonts/icons/material-icons-regular.woff'
import MaterialIconsWoff2 from '../assets/fonts/icons/material-icons-regular.woff2'

import DmSansWoff from '../assets/fonts/dm-sans/DMSans-Regular.woff'
import DmSansWoff2 from '../assets/fonts/dm-sans/DMSans-Regular.woff2'

import DmSansItalicWoff from '../assets/fonts/dm-sans/DMSans-Italic.woff'
import DmSansItalicWoff2 from '../assets/fonts/dm-sans/DMSans-Italic.woff2'

import DmSansBoldWoff from '../assets/fonts/dm-sans/DMSans-Bold.woff'
import DmSansBoldWoff2 from '../assets/fonts/dm-sans/DMSans-Bold.woff2'

import DmSansBoldItalicWoff from '../assets/fonts/dm-sans/DMSans-BoldItalic.woff'
import DmSansBoldItalicWoff2 from '../assets/fonts/dm-sans/DMSans-BoldItalic.woff2'

import FFCondensedMediumWoff from '../assets/fonts/ff/CondensedMedium.woff'
import FFCondensedMediumWoff2 from '../assets/fonts/ff/CondensedMedium.woff2'

import FFCondensedRegularWoff from '../assets/fonts/ff/CondensedRegular.woff'
import FFCondensedRegularWoff2 from '../assets/fonts/ff/CondensedRegular.woff2'

import SuisseIntlLightWoff from '../assets/fonts/suisse-intl/SuisseIntl-Light.woff'
import SuisseIntlLightWoff2 from '../assets/fonts/suisse-intl/SuisseIntl-Light.woff2'

import SuisseIntlThinWoff from '../assets/fonts/suisse-intl/SuisseIntl-Thin.woff'
import SuisseIntlThinWoff2 from '../assets/fonts/suisse-intl/SuisseIntl-Thin.woff2'

import SuisseIntlThinItalicWoff from '../assets/fonts/suisse-intl/SuisseIntl-ThinItalic.woff'
import SuisseIntlThinItalicWoff2 from '../assets/fonts/suisse-intl/SuisseIntl-ThinItalic.woff2'

import SuisseIntlUltraLightWoff from '../assets/fonts/suisse-intl/SuisseIntl-UltraLight.woff'
import SuisseIntlUltraLightWoff2 from '../assets/fonts/suisse-intl/SuisseIntl-UltraLight.woff2'

import SuisseIntlWoff from '../assets/fonts/suisse-intl/SuisseIntl.woff'
import SuisseIntlWoff2 from '../assets/fonts/suisse-intl/SuisseIntl.woff2'

import SuisseIntlWoffBook from '../assets/fonts/suisse-intl/SuisseIntl-Book.woff'
import SuisseIntlWoffBook2 from '../assets/fonts/suisse-intl/SuisseIntl-Book.woff2'

import SuisseIntlWoffRegular from '../assets/fonts/suisse-intl/SuisseIntl-Regular.woff'
import SuisseIntlWoffRegular2 from '../assets/fonts/suisse-intl/SuisseIntl-Regular.woff2'

import SuisseIntlMediumWoff from '../assets/fonts/suisse-intl/SuisseIntlMedium.woff'
import SuisseIntlMediumWoff2 from '../assets/fonts/suisse-intl/SuisseIntlMedium.woff2'

import SuisseIntlSemiBoldWoff from '../assets/fonts/suisse-intl/SuisseIntl-SemiBold.woff'
import SuisseIntlSemiBoldWoff2 from '../assets/fonts/suisse-intl/SuisseIntl-SemiBold.woff2'

import SuisseIntlCondTrialMediumWoff from '../assets/fonts/suisse-intl/SuisseIntlCondTrialMedium.woff'
import SuisseIntlCondTrialMediumWoff2 from '../assets/fonts/suisse-intl/SuisseIntlCondTrialMedium.woff2'

import SuisseIntlCondTrialSemiBoldWoff from '../assets/fonts/suisse-intl/SuisseIntlCondTrialSemiBold.woff'
import SuisseIntlCondTrialSemiBoldWoff2 from '../assets/fonts/suisse-intl/SuisseIntlCondTrialSemiBold.woff2'

export const fontFace = (
  fontName,
  woff,
  woff2,
  fontWeight = 'normal',
  fontStyle = 'normal'
) => `
	@font-face {
		font-family: '${ fontName }';
		src:  url('${ woff }') format('woff'),
					url('${ woff2 }') format('woff2');
		font-weight: ${ fontWeight };
		font-style: ${ fontStyle };
		font-display: swap;
	}
`
export const MaterialIcons = 'Material Icons'
export const MaterialIconsFont = fontFace(
  MaterialIcons,
  MaterialIconsWoff,
  MaterialIconsWoff2
)

export const DmSans = 'DM Sans'
export const DmSansFont = fontFace(DmSans, DmSansWoff, DmSansWoff2)
export const DmSansItalicFont = fontFace(
  DmSans,
  DmSansItalicWoff,
  DmSansItalicWoff2,
  'normal',
  'italic'
)
export const DmSansBoldFont = fontFace(
  DmSans,
  DmSansBoldWoff,
  DmSansBoldWoff2,
  '600'
)
export const DmSansBoldItalicFont = fontFace(
  DmSans,
  DmSansBoldItalicWoff,
  DmSansBoldItalicWoff2,
  '600',
  'italic'
)

export const FFCondensed = 'FF Condensed'
export const FFCondensedReg = 'FF Condensed Reg'
export const FFCondensedFont = fontFace(
  FFCondensed,
  FFCondensedMediumWoff,
  FFCondensedMediumWoff2
)
export const FFCondensedRegularFont = fontFace(
  FFCondensedReg,
  FFCondensedRegularWoff,
  FFCondensedRegularWoff2,
  '600'
)

export const SuisseIntl = 'SuisseIntl'
export const SuisseIntlFont = fontFace(
  SuisseIntl,
  SuisseIntlWoff,
  SuisseIntlWoff2,
  '400'
)
export const SuisseIntlLightFont = fontFace(
  SuisseIntl,
  SuisseIntlLightWoff,
  SuisseIntlLightWoff2,
  '300'
)
export const SuisseIntlThinFont = fontFace(
  SuisseIntl,
  SuisseIntlThinWoff,
  SuisseIntlThinWoff2,
  '200'
)
export const SuisseIntlThinItalicFont = fontFace(
  SuisseIntl,
  SuisseIntlThinItalicWoff,
  SuisseIntlThinItalicWoff2,
  'thin',
  'italic'
)
export const SuisseIntlUltraLightFont = fontFace(
  SuisseIntl,
  SuisseIntlUltraLightWoff,
  SuisseIntlUltraLightWoff2,
  '100',
  'italic'
)

export const SuisseIntlBookFont = fontFace(
  SuisseIntl,
  SuisseIntlWoffBook,
  SuisseIntlWoffBook2,
  '500'
)
export const SuisseIntlRegularFont = fontFace(
  SuisseIntl,
  SuisseIntlWoffRegular,
  SuisseIntlWoffRegular2,
  '600'
)

export const SuisseIntlSemiBold = fontFace(
  SuisseIntl,
  SuisseIntlSemiBoldWoff,
  SuisseIntlSemiBoldWoff2,
  '700'
)

export const SuisseIntlMedium = fontFace(
  SuisseIntl,
  SuisseIntlMediumWoff,
  SuisseIntlMediumWoff2,
  '400'
)

export const SuisseIntlCondTrialMedium = fontFace(
  SuisseIntl,
  SuisseIntlCondTrialMediumWoff,
  SuisseIntlCondTrialMediumWoff2,
  '800'
)

export const SuisseIntlCondTrialSemiBold = fontFace(
  SuisseIntl,
  SuisseIntlCondTrialSemiBoldWoff,
  SuisseIntlCondTrialSemiBoldWoff2,
  '900'
)
